define('views/pagination',[
  // These are path alias that we configured in our bootstrap
  'jquery', 'underscore', 'backbone', 'classes/templator'],
  function($, _, Backbone, templator) {

    return Backbone.View.extend({

      initialize: function() {
      },

      template: templator.pagination,

      render: function(paginator) {
        this.$el.html(this.template({paginator: paginator}));

        // horrible hack, for updating "Displaying 1 - 10" text
        $('#se-start').html(paginator.start);
        $('#se-end').html(paginator.end);
      }

    });

  }

);
